const e = "_border_1e4c6_9", t = {
  "timeline-section": "_timeline-section_1e4c6_1",
  border: e,
  "timeline-section--item": "_timeline-section--item_1e4c6_18"
};
export {
  e as border,
  t as default
};
